module.exports = __webpack_public_path__ + "static/media/09_tn.ce23d249.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/09_tn.jpg
// module id = 223
// module chunks = 0